import axios from 'axios';

const params = {
    IsMiddleware: false,
    Limit: 10,
    Bias: false
};

export default {
    state: {
        suggestedAddresses: []
    },
    getters: {
        suggestedAddresses(state) {
            return state.suggestedAddresses;
        }
    },
    mutations: {
        setSuggestedAddresses(state, data) {
            state.suggestedAddresses = data;
        }
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        retrieveAddress({ commit, state, rootState }, payload) {
            const apiString = `${rootState.actionURLs['Loqate-Retrieve']}`;
            return axios({
                method: 'post',
                url: apiString,
                data: new URLSearchParams({
                    Key: window.vue.customPreferences.loqateKey,
                    Id: payload.id
                }).toString(),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
        },
        // eslint-disable-next-line no-unused-vars
        getSuggestedAddresses({ commit, state, rootState }, payload) {
            const apiString = `${rootState.actionURLs['Loqate-Find']}`;
            return axios({
                method: 'post',
                url: apiString,
                data: new URLSearchParams({
                    Key: window.vue.customPreferences.loqateKey,
                    Language: rootState.vueVariables ? rootState.vueVariables.locale : rootState.pdict.locale,
                    Text: payload.text,
                    Container: payload.container,
                    Countries: rootState.forms.formFields[payload.formName].country,
                    ...params
                }).toString(),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
                .then((responseData) => {
                    if (responseData.data.Items.length === 0 || (responseData.data.Items.length === 1 && typeof responseData.data.Items[0].Error !== 'undefined')) {
                        commit('setSuggestedAddresses', []);
                        return;
                    }

                    commit('setSuggestedAddresses', responseData.data.Items);
                })
                .catch(() => {
                });
        }
    }
};
